import React from "react";
import MaxWidthContainer from "@src/components/containers/MaxWidthContainer";

export default function AdminComingSoonPage(): React.JSX.Element {
  return (
    <MaxWidthContainer>
      <div
        className="spaced-content-xl"
        style={{ textAlign: "center", paddingTop: "4rem" }}
      >
        <h1>Admin Portal</h1>
        <p>This portal is coming soon.</p>
      </div>
    </MaxWidthContainer>
  );
}
